import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { isDevEnvironment } from 'src/utils/isDevEnvironment';
import { LanguageRegionCodeSchema, type LanguageRegionCode } from 'src/types';
import consentSettingsENUS from 'src/locales/en-US/consentSettings.translations.json';
import consentSettingsENCA from 'src/locales/en-CA/consentSettings.translations.json';
import consentSettingsFRCA from 'src/locales/fr-CA/consentSettings.translations.json';

const LANGUAGE_UNDEFINED_MSG = 'Language is undefined';

const resources = {
    'en-US': {
      translation: consentSettingsENUS,
    },
    'en-CA': {
      translation: consentSettingsENCA
    },
    'fr-CA': {
      translation: consentSettingsFRCA
    }
}  

export const getSelectedLanguage = (): LanguageRegionCode => {
    try {
        const htmlLang = document.documentElement.lang;
        const formattedLang = Intl.getCanonicalLocales(htmlLang);
        if (formattedLang.length === 0) {
            throw new RangeError(LANGUAGE_UNDEFINED_MSG);
        }
        return LanguageRegionCodeSchema.parse(formattedLang[0]);
    } catch (err) {
        console.error(err);
        const tld = window.location.hostname.split('.').at(-1);
        if (tld === 'ca') {
            return 'en-CA';
        } else {
            return 'en-US';
        }
    }
};

export const isCA = (locale: LanguageRegionCode): boolean => {
    return typeof locale !== 'undefined' && (locale === 'en-CA' || locale === 'fr-CA');
}

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
        resources,
        lng: getSelectedLanguage(),
        fallbackLng: 'en-US',
        debug: isDevEnvironment(),
        interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
